import * as fs from "fs/promises";
import type { StorageImageTransformMetric, StorageMeteringOptions } from "./storage-types.js";

export async function recordStorageImageTransform(
  options: StorageMeteringOptions | undefined,
  cachePath: string,
  metric: Omit<StorageImageTransformMetric, "transformCount" | "outputBytes">,
): Promise<{ size: number }> {
  const stats = await fs.stat(cachePath);
  await recordStorageImageTransformSize(options, stats.size, metric);
  return stats;
}

export async function recordStorageImageTransformSize(
  options: StorageMeteringOptions | undefined,
  outputBytes: number,
  metric: Omit<StorageImageTransformMetric, "transformCount" | "outputBytes">,
): Promise<{ size: number }> {
  if (!options?.onImageTransform) return { size: outputBytes };

  try {
    await options.onImageTransform({
      ...metric,
      transformCount: 1,
      outputBytes,
    });
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    console.warn(`[storage] image transform metering failed: ${msg.slice(0, 120)}`);
  }

  return { size: outputBytes };
}
